import React, { Component } from 'react';
import { connect } from 'react-redux';
import { cekCookies } from '../../../../../actions';
import __, { split } from 'lodash';
import { Row, Col, Alert, Table } from 'react-bootstrap';
import LoaderModal from '../../../../modal/LoaderModal';
import Navbar from '../../../navbar/Navbar';
import Sidebar from '../../../sidebar/Sidebar';
import { CONFIG } from '../../../../../config';
import accountManagement from '../../../../../apis/accountManagement';
import { Doughnut, Radar, Polar, Pie } from 'react-chartjs-2';
import './peminatan.css';
import { Message } from '@material-ui/icons';
// import response from './responseDetailKu.json';

class ReportDetailKu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            message: null,
            detailSiswa: {},
            placementIpa: [],
            placementIps: [],
            placementBhs: [],
            detailSiswa: null

        }
    }
    async componentDidMount() {
        this.setState({ isFetching: true, error: false });
        await this.props.cekCookies();
        console.clear();
        console.info('PROPS :: DETAIL-KU', this.props);
        console.info('CEK REPORT DETAIL KU', this.props.params.placementIpa);

        if (!__.isEmpty(this.props.account)) {
            this.setState({
                detailSiswa: this.props.params.namaSekolah,
                placementIpa: this.props.params.placementIpa,
                placementIps: this.props.params.placementIps,
                placementBhs: this.props.params.placementBhs
            });
        }

        this.setState({
            isFetching: false
        });
    }

    render() {
        const { detailSiswa, placementIpa, placementIps, placementBhs, error } = this.state;

        return (
            <div className="container-fluid" style={{ padding: '10px', width: '1000px' }}>
                <LoaderModal isFetching={this.state.isFetching} />
                {!error && <>
                    <div className="cardLine">
                        <div className="pnl-header">
                            <div className="card-page">
                                <span style={{
                                    fontSize: '26px',
                                    color: '#FFF',
                                    fontWeight: 500,
                                    fontFamily: 'lucida grande'
                                }}>01</span>
                            </div>
                            <div className="pnl-date">
                                https://eduprime.co.id/
                            </div>
                        </div>
                        <div style={{ margin: '30px 0 30px' }}>
                            <div className="title-header2" style={{ color: '#015E56' }}>REKAPITULASI NILAI TES KECAKAPAN UMUM</div>
                            <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
                                <div className="label-sub-tit" style={{width: '15%'}}>
                                    <span className="sub-title-header" style={{ color: '#FFF' }}>SEKOLAH</span>
                                </div>
                                <div className="logo-an" style={{width: '20%', margin: '30px 0 10px'}}>
                                    <img src="/assets/image/LOGO_PEMINATAN_1.png" width={"100%"} />
                                </div>
                            </div>
                        </div>
                        <div>
                            <table width="100%">
                                <tbody>
                                    <tr>
                                        <td colSpan="4">KETERANGAN</td>
                                    </tr>
                                    <tr>
                                        <td style={{ "width": "3%" }}><div className="ling-vs-ku" /></td> <td>Very Superior</td>
                                        <td style={{ "width": "3%" }}><div className="ling-hs-ku" /></td> <td>High Superior</td>
                                        <td style={{ "width": "3%" }}><div className="ling-s-ku" /></td> <td>Superior</td>
                                        <td style={{ "width": "3%" }}><div className="ling-a-ku" /></td> <td>Average</td>
                                    </tr>
                                    <tr>
                                        <td style={{ "width": "3%" }}><div className="ling-la-ku" /></td> <td>Low Average</td>
                                        <td style={{ "width": "3%" }}><div className="ling-b-ku" /></td> <td>Borderline</td>
                                        <td style={{ "width": "3%" }}><div className="ling-mr-ku" /></td> <td>Mentally Retarded</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div style={{ width: '100%' }}>
                            <div style={{ marginBottom: '10px', textAlign: 'right' }}>
                                <b>Placement IPA</b>
                            </div>

                            <table width="100%">
                                <tbody>
                                    <tr className="header-biru-putih header-putih-kecil" key="10000">
                                        <td style={{ "width": "5%" }}>NO</td>
                                        <td style={{ "width": "50%", "text-align": "-webkit-left" }}>NAMA</td>
                                        <td style={{ "width": "20%" }}>SKOR</td>
                                        <td>KESIMPULAN</td>
                                    </tr>
                                    {
                                        placementIpa.map((val, i) =>
                                            <tr key={i}>
                                                <td className="tabel-siswa-placement-center"><p className="text-normal-iq">{i + 1}</p></td>
                                                <td><p className="text-normal-iq">{val.namaSiswa}</p></td>
                                                <td className="tabel-siswa-placement-center"><p className="text-normal-iq">{parseInt(val.skor)}</p></td>
                                                <td className="tabel-siswa-placement-center"><div className={val.result} /></td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                        <div style={{ width: '100%' }}>
                            <div style={{ marginBottom: '10px', textAlign: 'right' }}>
                                <b>Placement IPS</b>
                            </div>
                            <table width="100%">
                                <tbody>
                                    <tr className="header-biru-putih header-putih-kecil" key="10000">
                                        <td style={{ "width": "5%" }}>NO</td>
                                        <td style={{ "width": "50%", "text-align": "-webkit-left" }}>NAMA</td>
                                        <td style={{ "width": "20%" }}>SKOR</td>
                                        <td>KESIMPULAN</td>
                                    </tr>
                                    {
                                        placementIps.map((val, i) =>
                                            <tr key={i}>
                                                <td className="tabel-siswa-placement-center"><p className="text-normal-iq">{i + 1}</p></td>
                                                <td><p className="text-normal-iq">{val.namaSiswa}</p></td>
                                                <td className="tabel-siswa-placement-center"><p className="text-normal-iq">{parseInt(val.skor)}</p></td>
                                                <td className="tabel-siswa-placement-center"><div className={val.result} /></td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                        <div style={{ width: '100%' }}>
                            <div style={{ marginBottom: '10px', textAlign: 'right' }}>
                                <b>Placement BAHASA</b>
                            </div>
                            <table width="100%">
                                <tbody>
                                    <tr className="header-biru-putih header-putih-kecil" key="10000">
                                        <td style={{ "width": "5%" }}>NO</td>
                                        <td style={{ "width": "50%", "text-align": "-webkit-left" }}>NAMA</td>
                                        <td style={{ "width": "20%" }}>SKOR</td>
                                        <td>KESIMPULAN</td>
                                    </tr>
                                    {
                                        placementBhs.map((val, i) =>
                                            <tr key={i}>
                                                <td className="tabel-siswa-placement-center"><p className="text-normal-iq">{i + 1}</p></td>
                                                <td><p className="text-normal-iq">{val.namaSiswa}</p></td>
                                                <td className="tabel-siswa-placement-center"><p className="text-normal-iq">{parseInt(val.skor)}</p></td>
                                                <td className="tabel-siswa-placement-center"><div className={val.result} /></td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                        <div style={{ width: '100%' }}>
                            <div style={{ marginBottom: '10px', textAlign: 'right' }}>
                                <b>Placement BAHASA</b>
                            </div>
                            <table width="100%">
                                <tbody>
                                    <tr className="header-biru-putih header-putih-kecil" key="10000">
                                        <td style={{ "width": "5%" }}>NO</td>
                                        <td style={{ "width": "50%", "text-align": "-webkit-left" }}>NAMA</td>
                                        <td style={{ "width": "20%" }}>SKOR</td>
                                        <td>KESIMPULAN</td>
                                    </tr>
                                    {
                                        placementBhs.map((val, i) =>
                                            <tr key={i}>
                                                <td className="tabel-siswa-placement-center"><p className="text-normal-iq">{i + 1}</p></td>
                                                <td><p className="text-normal-iq">{val.namaSiswa}</p></td>
                                                <td className="tabel-siswa-placement-center"><p className="text-normal-iq">{parseInt(val.skor)}</p></td>
                                                <td className="tabel-siswa-placement-center"><div className={val.result} /></td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div id="btn_print">
                        <div className="fixed_button">
                            <button className="btn btn-outline-danger pull-left" title="Kembali" style={{ marginLeft: '1em' }} onClick={() => this.props.tutupReportDetail()}>
                                <li className="fa fa-arrow-left"></li>
                            </button>
                            &nbsp;
                            <button className="btn btn-outline-primary  pull-right" title="Print Report" style={{ marginRight: '1em' }} onClick={() => window.print()}>
                                <li className="fa fa-print"></li>
                            </button>
                        </div>
                    </div>
                </>}
            </div>
        );
    }

}

const mapStateToProps = (state) => {
    return {
        account: state.account
    };
}

export default connect(mapStateToProps, { cekCookies })(ReportDetailKu);
